import fetch from '@/utils/fetch'

export function getBrandLogo () {
  return fetch({
    url: '/companys/setting',
    method: 'get'
  })
}

//獲取分享設定
export function getShareParams () {
  return fetch({
    url: '/shareParameters/setting',
    method: 'get'
  })
}

//設定分享設定
export function saveShareParams (data) {
  return fetch({
    url: '/shareParameters/setting',
    method: 'post',
    params: data
  })
}
